export default "<noctua-progress-bar></noctua-progress-bar>\r\n<ng-container>\r\n  <layout-noctua></layout-noctua>\r\n</ng-container>\r\n"